import { useTheme } from '@mui/styles';

export const useSxStyles = () => {
  const theme = useTheme();
  return {
    button: {
      borderRadius: theme.spacing(1.5),
      margin: theme.spacing(0, 0.5),
      paddingRight: theme.spacing(1.5),
    },
  };
};
